import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { CodeWindow } from "@/components/shapes/shared/card-visual-parts";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { codeFrameLanguage, codeFrameText } from "./code-content";

const MAX_LINES = 8;

/**
 * Code (mockup `.term`): its file name (else its language) as the first
 * muted line, then its first lines.
 */
export function CodeCardPreview(props: CardPreviewProps) {
  const lines = codeFrameText(props.source).split("\n").slice(0, MAX_LINES);
  if (!lines.some((line) => line.trim())) {
    return <GenericCardPreview {...props} />;
  }
  return (
    <CodeWindow density={props.density} data-testid="code-card">
      <p
        className="truncate text-[color:var(--gadget-code-muted)]"
        data-testid="code-card-name"
      >
        {props.frame.title.trim() || codeFrameLanguage(props.source)}
      </p>
      <pre
        className="overflow-hidden whitespace-pre font-mono"
        data-testid="code-card-lines"
      >
        {lines.join("\n")}
      </pre>
    </CodeWindow>
  );
}
